import React, {useState, useEffect} from "react";
import {useNavigate, useLocation, Link} from "react-router-dom";
import {normalizeInput, normalizeDate, calculate_age, isvalid_mdy,normalizeUSDate} from '../functions';
import  {updateMembership} from "../../API/APICalls";


export default function CancelMembershipForm () {

    const navigate = useNavigate();
    const location = useLocation();

    const [isAutoRenew, setisAutoRenew] = useState(true);
    const [alert, setAlert] = useState('ms-2 alert alert-danger');
    const [message, setMessage] = useState('');
    const [inputs, setInputs] = useState({cancelOption: '', cancelReason: '', comments: ''});
    const [commentRequired, setCommnentRequired] = useState<boolean>(false);
    const [panel, setPanel] = useState("collapse hide");
    const [pagepanel, setPagePanel] = useState("collapse show");
    const [confirmpanel, setConfirmPanel] = useState("collapse hide");
    const [isLoading, setIsLoading] = useState(true);
    

    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) => {
     
        setPanel("collapse show");

        if (value === "other")
            {
                 setCommnentRequired(true);
            } else {
                 setCommnentRequired(false);
            }

        
        setInputs(inputs => ({ ...inputs, [name]: value }));
    }

    let membershipData = location.state.membership;

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);

           

        //call api       
        const response = await updateMembership(location.state.dealId, inputs.cancelOption, inputs.cancelReason, inputs.comments, location.state.handicap_id);
           
            setAlert('ms-2 alert alert-success');
            setMessage("Your have successfully canceled your membership. Please check your email for confirmation.");

            setPagePanel("collapse hide");
            setConfirmPanel("collapse show");
            setIsLoading(false);
        

    }

    useEffect(() => {
        
        setIsLoading(false);
    }, []);

  


    return (
        <div className="container page_container mb-5 pb-5">
            
            {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
            </div>
            : ''}


            { pagepanel === "collapse show" ? 
            <form onSubmit={handleSubmit}>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-5 ">
                    <h2 className="fs-1 text-left pt-3">When would you like to cancel your USGA AGA GC membership?</h2>
                </div>

                
                <div className="row">
                    <div className="col-12">
                        <div className="form-check pb-3">
                            <input className="form-check-input fs-4" type="radio" name="cancelOption" id="flexRadioDefault1" onChange={handleChange} value="immediately" required/>
                            <label className="form-check-label fs-4" htmlFor="flexRadioDefault1">
                                Cancel my membership immediately
                              
                                    <ul>
                                        <li className="text-secondary">The affiliation to {membershipData.aga_club_name} will be inactivated.</li>
                                        <li className="text-secondary">This will not impact the membership status with other clubs.</li>
                                    </ul>
                                
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input fs-4" type="radio" name="cancelOption" id="flexRadioDefault2" onChange={handleChange} value="donotrenew" required/>
                            <label className="form-check-label fs-4" htmlFor="flexRadioDefault2">
                                Do Not Renew the membership when it expires on <span className="fw-bold fs-4">{normalizeUSDate(membershipData.expiration_date)}</span>
                               
                                    <ul><li className="text-secondary">This will not impact the membership status with other clubs.</li></ul>
                                
                            </label>
                        </div>

                        <div className="col-12"><p className="text-danger">{message}</p></div>
                    </div>

                    
                </div>

                

            </div>

            {panel !== "collapse hide" ? 
            <div className="row">
            <div className="col-12 fs-4 pe-3">Please provide us with a reason why you are canceling your membership.</div>
            <div className="col-12 pb-3"><span>Select atleast one reason:</span></div>
                    <div className="col-12">
                        <ul className="list-group fs-5">
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="cancelReason" value="joininganotherclub" checked={inputs.cancelReason === "joininganotherclub"} onChange={handleChange} required/>
                                Have or will be joining another club
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="cancelReason" value="moving" checked={inputs.cancelReason === "moving"} onChange={handleChange} required/>
                                Have or will be moving
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="cancelReason" value="pricetoohigh" checked={inputs.cancelReason === "pricetoohigh"}  onChange={handleChange} required/>
                                Priced too high
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="cancelReason" value="didnotplayenough" checked={inputs.cancelReason === "didnotplayenough"} onChange={handleChange} required/>
                                Lack of time/did not play enough
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="cancelReason" value="illnessorinjury" checked={inputs.cancelReason === "illnessorinjury"} onChange={handleChange} required/>
                                Illness or injury
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="cancelReason" value="other" checked={inputs.cancelReason === "other"} onChange={handleChange} required/>
                                Other – Please specify
                            </li>
                        </ul>
                    </div>

                    <div className="col-12 pb-4">
                        <div className="col-12 py-3"><span className="pt-4 fs-4">Additional Comments:</span></div>
                        <textarea className="form-control" id="message-text" rows={8} name="comments" onChange={handleChange} required={commentRequired}>

                        </textarea>
                    
                </div>
                </div>
                : ''}

                    <div className="mt-4 col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12 col-xl-12 col-xxl-12 pt-4">
                            <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 order-1 pt-3">
                                <Link to="/membership/dashboard" state={{"contact_guid": location.state.contact_guid, "handicap_id" : location.state.handicap_id}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                                    BACK
                                </Link>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 order-sm-1 order-lg-1 pt-3">
                                <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                                    CONTINUE
                                </button>
                            </div>
                        </div>


                        </div>


            </form> : '' }


            { confirmpanel === "collapse show" ? 
                    <div className="row col-10 py-5 mx-auto text-center">
                    <div className={alert} role="alert">
                    {message}
                    </div>
                    <div className="fs-5">Thank you!</div>
                    <div className="fs-5">If you have any questions about your membership, please email <a href="mailto:gcsupport@usga.org">gcsupport@usga.org</a>.</div>
                    <div className="row">
                            <div className="col-12 col-sm-10 col-md-10 mx-auto pt-3">
                                <Link to="/membership/dashboard" state={{"contact_guid": location.state.contact_guid, "handicap_id": location.state.handicap_id}} className="w-100 btn btn-outline-primary btn-lg rounded-pill px-5 " type="button">
                                    Manage Memberships
                                </Link>
                            </div>

                    </div>
                </div>
                    
                
                : ''
                }
        </div>
)

}
